import Api from './Indicadores'
export default {
    getByStage(id){
        return Api().get("/period/stage/"+id);
    },
    createperiod(data){
        return Api().post("/period/create/",data);
    },
    updateperiod(data){
        return Api().post("/period/update/",data);
    },
    deleteperiod(id){
        return Api().delete("/period/delete/"+id);
    },
    kpiEnable(id){
        return Api().post("/period/kpi-enable/"+id+"/1")
    },
    kpiDisable(id){
        return Api().post("/period/kpi-enable/"+id+"/0")
    },
    setCurrent(id){
        return Api().post("/period/set/default/"+id)
    },
    getByMaster(id){
        return Api().get('/period/master/'+id)
    },
    getByMasterAndStage(id, stage){
        return Api().get('/period/master/'+id+ '/'+ stage)
    }
}